import Http from "../http";

class UserServices {
    static async getAllUsers() {
        console.log('=================================================================i am in the userservices', )
        return Http.get('/users');
      }
      static async getUserTripCount(){
        return Http.get('/user-trip-count')
      }
      static async getUserById(id){
        return Http.get(`/users/${id}`);
      }
      static async getUserTripDetails(id){
        return Http.get(`/user-trip-details/${id}`)
      }
      static  async updateUser(id,data){
        return Http.update(`/users/${id}`,data)
      }
      static async updateFollowUp(data){
        return Http.update('/updateUserFollowUp',data);
      }
      static async getFollowUp(){
        return Http.get("/userFollowUp");
      }
}
export default UserServices;